export default __webpack_public_path__ + "static/media/sdg17_FDI_bullet.94997bcd.png";